import type { ReactNode } from "react";
import { PermissionScopeContext } from "./permission-scope-context";

export default function PermissionScope({
  profileId,
  children,
}: {
  profileId?: number | null;
  children: ReactNode;
}) {
  return (
    <PermissionScopeContext.Provider value={profileId ?? null}>
      {children}
    </PermissionScopeContext.Provider>
  );
}
